// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import VueQuillEditor from 'vue-quill-editor'
// Vue.use(VueQuillEditor);
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './vuex/store';
import vant from 'vant'
// import 'vant/lib/index.css'
import VueLazyLoad from 'vue-lazyload';
Vue.use(VueLazyLoad,{
	error:'', // 加载错误的图片
	loading:'' // 加载时的图片
});
// import './assets/svg'//引入svg文件
// import icon from '././components/svgIcon.vue'//引入写好的组件
// Vue.component('icon', icon)//全局调用
Vue.use(vant)
import vueEsign from 'vue-esign';
Vue.use(vueEsign)
import axios from 'axios';
Vue.prototype.$axios = axios;
import qs from 'qs'
Vue.prototype.qs = qs;
axios.defaults.withCredentials = true;
axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}


axios.defaults.baseURL = process.env.API_ROOT;
//axios.defaults.baseURL = 'https://www.zhengyirc.com/zny';

axios.defaults.timeout = 350000;

// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'DvY2lKKBaNthnAtgRnHo1Qv8WCQGPAgI'
// })
// require styles
// import 'swiper/css/swiper.css'
import '../static/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js